import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { DocrenPage } from './docren';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
    declarations: [
        DocrenPage
    ],
    imports: [        
        ComponentsModule,
        IonicPageModule.forChild(DocrenPage),
    ],
})
export class DocrenPageModule { }



// WEBPACK FOOTER //
// ./src/pages/docren/docren.module.ts